export default __webpack_public_path__ + "static/media/Composite_finished.2a32d6a8.jpg";